import { directoryApiClient, exchangeToken } from './auth'
import { setupTokenRefresh } from './tokenRefresh'
import { environmentVariables } from '../../utils/environmentVariables'

export const initTokenRefresh = (): void => {
  setupTokenRefresh(
    directoryApiClient,
    exchangeToken,
    `${environmentVariables('AUTH_API_URL')}/signin`,
  )
}
